import React from 'react';
import { IonContent } from '@ionic/react';
import './DigitalDashboardSkeletonLoader.scss';

interface DigitalDashboardSkeletonLoaderProps {
  variant?: 'mobile' | 'desktop';
}

const DigitalDashboardSkeletonLoader: React.FC<
  DigitalDashboardSkeletonLoaderProps
> = ({ variant = 'mobile' }) => {
  function SkeletonBody() {
    return (
      <>
        <div className="digital-dashboard-skeleton-toggle-container">
          <span>
            <div className="digital-dashboard-skeleton-toggle" />
            <div className="digital-dashboard-skeleton-toggle" />
          </span>
          <div className="digital-dashboard-skeleton-cog" />
        </div>
        <div className="digital-dashboard-skeleton-title" />
        {[0, 1, 2].map((i) => (
          <div
            className="digital-dashboard-skeleton-card"
            key={`digital-dashboard-skeleton-card-${i}`}
          >
            <div className="digital-dashboard-skeleton-card-thumbnail" />
            <div className="digital-dashboard-skeleton-card-body">
              <div className="digital-dashboard-skeleton-card-line short" />
              <div className="digital-dashboard-skeleton-card-line long" />
            </div>
            <div className="digital-dashboard-skeleton-card-badge" />
          </div>
        ))}
      </>
    );
  }

  if (variant === 'desktop') {
    return (
      <div className="digital-dashboard-skeleton-desktop">
        <div className="digital-dashboard-skeleton-desktop-profile-card" />
        <SkeletonBody />
      </div>
    );
  }

  return (
    <IonContent
      color="white"
      className="digital-dashboard-skeleton ion-padding"
      fullscreen
    >
      <div className="digital-dashboard-skeleton-header" />
      <SkeletonBody />
    </IonContent>
  );
};

export default DigitalDashboardSkeletonLoader;
